<template>
  <div class="cplan-unit-card-outer">
    <div class="cplan-unit-card">
      <div :class="['cplan-unit-card__type-label', labelClass]">{{ unit.firstLevelTitle }}</div>

      <div class="cplan-unit-card__top">
        <div class="cplan-unit-card__head">
          <div class="cplan-unit-card__code">{{ unit.code }}</div>
          <div class="cplan-unit-card__credits">{{ unit.creditPoints }} credit points</div>
        </div>
        <div class="cplan-unit-card__title">
          <button type="button" class="btn-link-bold" v-on:click="clickUnitTitle">{{ unit.name }}</button>
        </div>
      </div>
      <div v-if="isReviewer" class="cplan-unit-card__actions">
        <div class="cplan-unit-card__status-version-badges">
          <div class="badge" :class="unit.status != 'Active' ? 'badge-primary' : 'badge-success'">{{ statusLabel(unit.status) }}</div>
          <div class="badge badge-secondary">v{{ unit.courseLoopVersionNumber || unit.version }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SlideOutUnitDetailsView from '../select-units/slide-out-tree-view/SlideOutUnitDetailsView.vue'

export default {
  props: {
    unit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView
    }
  },
  computed: {
    ...mapGetters({
      isReviewer: 'global/isReviewer',
    }),
    labelClass() {
      return `unit-${this.unit.firstLevelTitle.toLowerCase().replace(/\s/gi, '-')}`
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    }),
    statusLabel(id) {
      return this.__(`label:status ${id.toLowerCase()}`)
    },
    // in order for the slideout to work, we need the following fields
    // location,
    clickUnitTitle() {
      this.openSlideOut({
        component: this.slideOutComponent,
        componentProperties: { relationship: this.unit, location: this.unit.name, firstLevelTitle: this.unit.firstLevelTitle, reviewMode: true }
      })
    }
  },
  mounted() {}
}
</script>

